function get_next_video(published_date, videovertical) {
	
	$.ajax({
	    url: '/api/fe/get-next-video/',
	    type: 'GET',
	    data: {published: published_date, videovertical: videovertical},
	    success: function (response) {
	        if (response.status === 'error') {
	            console.log(response.message);
	        } else {
	        	var isyoutube =  $($.parseHTML(response)).filter("#ytplayer");
	        	if(isyoutube.length) {
	        		$('.embed-container').html(response).promise().done(function(){
				        youtubeplayer = new YT.Player('ytplayer', {
				            events: {
				                'onStateChange': onYoutubeplayerStateChangeVideoEntry
				            }
				        });
			    	});
	        	} else {
	        		$('.embed-container').html(response);

	        		//Check if it's a daily motion provider to setup the SDK.
	        		dailyMotionInit();
	        	}

	        }
	    }
	});
}